import { VALID_PUNCTUATION as N } from './contact-channels170.js';

function a(t){return t.replace(new RegExp("[".concat(N,"]+"),"g")," ").trim()}

export { a as default };
//# sourceMappingURL=contact-channels171.js.map
